import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrencyCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2427 3.75736C14.5858 6.10051 14.5858 9.89949 12.2427 12.2426C9.89954 14.5858 6.10055 14.5858 3.75742 12.2426C1.41427 9.89948 1.41427 6.10049 3.75742 3.75736C6.10057 1.41421 9.89955 1.41421 12.2427 3.75736",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3573 10.3575C9.05531 11.6595 6.94531 11.6595 5.64331 10.3575C4.34131 9.05549 4.34131 6.94549 5.64331 5.64349C6.94531 4.34149 9.05531 4.34149 10.3573 5.64349",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 7.07992H4",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 8.91976H4",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCurrencyCircle;
